import swal from 'sweetalert';

type Props = Readonly<{
    title: string;
    text?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
}>;

async function confirmationAlert({ title, text, onConfirm, onCancel }: Props): Promise<boolean> {
    const confirmed = await swal({ title, text, icon: 'warning', buttons: ['Cancel', true], dangerMode: true });

    if (onConfirm && confirmed) {
        onConfirm();
    }

    if (onCancel && !confirmed) {
        onCancel();
    }

    return confirmed;
}

export default confirmationAlert;
